import { ProductKeys } from "@atlassiansox/asc-stargate";

import { SiteSelectorContextProvider } from "@/components/site-selector-modal";
import { SitesContextProvider } from "@/components/sites-provider";
import { AgileOverviewPageTemplate } from "@/templates/agile-hub/src/agile-overview-page.template";
import { AgileOverviewProvider } from "@/templates/agile-hub/src/agile-overview.provider";
import { AgileOverview } from "@/templates/agile-hub/types";

export type AgileOverviewPageProps = {
    agileOverview: AgileOverview | null;
};

export const AgileOverviewPage = ({
    agileOverview
}: AgileOverviewPageProps) => (
    <SitesContextProvider>
        <SiteSelectorContextProvider
            analyticsPrefix="jira-software.ondemand" // TODO: Check if this is correct
            productKey={ProductKeys.JIRA_SOFTWARE}
        >
            <AgileOverviewProvider agileOverview={agileOverview}>
                <AgileOverviewPageTemplate />
            </AgileOverviewProvider>
        </SiteSelectorContextProvider>
    </SitesContextProvider>
);
